// a helper to convert a graphql photo entity
const reducePhoto = (photo) => {
	if (!photo) {
		return {};
	}

	return {
		info: {
			picid: photo.id,
		},
		"60x60": photo.square60,
		"82x82": photo.square82,
		"100x100": photo.square100,
		"120x120": photo.square120,
		"160x160": photo.square160,
		"225x225": photo.square225,
		"230x230": photo.square230,
		"400x400": photo.square400,
		"800x800": photo.square800,
	};
};

/**
 * Convert user data retrieved from GraphQL to the old Profile Fields format.
 * This allows us to use components like the UserCard with a simple transform,
 * which could eventually be deleted.
 * @param {Object} data - the graphql data
 * @return {Object} - the profile fields data
 */
const graphqlToUserModel = (data = {}) => {
	const res = {};

	// handle both a Match and User entity. a Match has user as a subfield.
	const user = data.user ? data.user : data;

	res.user_data = data.__stream;

	res.percentages = {
		match: data.matchPercent,
	};

	res.last_contacts = {
		forward: data.senderMessageTime,
		reverse: data.targetMessageTime,
	};

	if (data.firstMessage) {
		res.first_message = {
			messageid: data.firstMessage.id,
			threadid: data.firstMessage.threadId,
			body: data.firstMessage.text,
			profile_comment: data.profileComment,
		};

		if (data.firstMessage.time) {
			res.first_message.timestamp = data.firstMessage.time / 1000;
		}
	}

	res.likes = {
		you_like: !!data.senderLikeTime,
		they_like: !!data.targetLikeTime,
		mutual_like: !!data.senderLikeTime && !!data.targetLikeTime,
		mutual_like_vote: !!data.senderLikeTime && !!data.targetLikeTime,
		via_spotlight: !!data.targetLikeViaSpotlight,
		passed_on: !!data.senderPassed,
		vote: {
			// not sure of the significance of 2 vs 1; just not 0.
			fwd: data.senderLikeTime ? 2 : 0,
			rev: data.targetLikeTime ? 2 : 0,
			fwd_timestamp: data.senderLikeTime,
			rev_timestamp: data.targetLikeTime,
		},
	};

	res.userid = user.id;
	res.username = user.username;

	res.userinfo = {
		username: user.username,
		displayname: user.displayname,
		realname: user.realname,
		age: user.age,
	};

	if (user.location) {
		res.userinfo.location = user.location.summary;

		res.location = {
			locid: user.location.id,
			country_code: user.location.countryCode,
			state_code: user.location.stateCode,
			formatted: {
				short: user.location.summary,
				standard: user.location.summary,
			},
		};
	} else {
		res.location = {};
	}

	res.online = user.isOnline;

	if (user.photos) {
		res.thumbs = user.photos.map(reducePhoto);
	} else if (user.primaryImage) {
		res.thumbs = [reducePhoto(user.primaryImage)];
	} else {
		res.thumbs = [];
	}

	let essays;

	if (user.essays) {
		essays = user.essays;
	} else if (user.essaysWithUniqueIds) {
		essays = user.essaysWithUniqueIds;
	}

	if (essays) {
		res.essays = essays.map((essay) => ({
			essayid: essay.id,
			id: essay.id,
			essay_groupid: essay.groupId,
			group_type: essay.isPassion ? 1 : 0,
			sectionTitle: essay.groupTitle,
			title: essay.title,
			rawtext: essay.rawContent,
			contents: essay.processedContent,
			content: essay.processedContent,
			clean_content: essay.processedContent,
			placeholder: essay.placeholder,
			essay_pics: [reducePhoto(essay.picture)],
		}));
	}

	if (user.similarUsers && user.similarUsers.data) {
		res.similar_users = user.similarUsers.data;
	}

	if (user.detailSentences) {
		res.details = user.detailSentences.map(({ name, text }) => ({
			info: {
				name,
			},
			text: {
				text,
			},
		}));
	}

	return res;
};

export default graphqlToUserModel;



// WEBPACK FOOTER //
// ./src/shared/util/graphqlToUserModel.js